import React from 'react';
import { Text } from 'react-orange-ui';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const Container = styled.div`
  margin: 0.5rem 0;
`;

const Contact = ({ contact, caption, id }) => (
  <Container>
    <Text id={id}>
      {caption}
      <b id="contact-data">
        {contact.contactData || contact.contactView}
      </b>
    </Text>
  </Container>
);

Contact.defaultProps = {
  caption: '',
  id: 'contact',
};

Contact.propTypes = {
  /** All user contacts ways state */
  contact: PropTypes.shape({
    contactData: PropTypes.string,
    contactView: PropTypes.string,
    contactType: PropTypes.string,
  }).isRequired,
  /** String caption */
  caption: PropTypes.string,
  /** String identifier */
  id: PropTypes.string,
};

export default Contact;
